import { useState, useEffect } from "react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 flex items-center h-16 md:h-18 gap-6">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-7 h-7 flex items-center justify-center bg-[#1C1917] rounded-full">
              <span className="text-white text-xs font-bold tracking-tight">LK</span>
            </div>
            <span
              className={`text-sm font-semibold tracking-widest hidden sm:block transition-colors duration-300 ${
                scrolled ? "text-[#1C1917]" : "text-white"
              }`}
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              レディースキッド
            </span>
          </a>

          {/* Nav */}
          <nav className="hidden md:flex items-center gap-7 flex-1 justify-center">
            {[
              { label: "初めての方へ", href: "#about" },
              { label: "足タイプから探す", href: "#diagnosis" },
              { label: "お悩みから探す", href: "#troubles" },
              { label: "商品を見る", href: "#products" },
              { label: "来店・診断", href: "#consultation" },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`text-sm whitespace-nowrap transition-colors duration-300 hover:opacity-70 ${
                  scrolled ? "text-[#44403C]" : "text-white/90"
                }`}
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Right CTAs */}
          <div className="hidden md:flex items-center gap-2 flex-shrink-0 ml-auto">
            <a
              href="#line"
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap border transition-all duration-300 cursor-pointer ${
                scrolled
                  ? "border-[#1C1917] text-[#1C1917] hover:bg-[#1C1917] hover:text-white"
                  : "border-white text-white hover:bg-white hover:text-[#1C1917]"
              }`}
            >
              <i className="ri-line-fill text-sm" />
              LINE相談
            </a>
            <a
              href="#consultation"
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                scrolled
                  ? "bg-[#1C1917] text-white hover:bg-[#44403C]"
                  : "bg-white text-[#1C1917] hover:bg-white/90"
              }`}
            >
              来店予約
              <i className="ri-arrow-right-line text-xs" />
            </a>
            <a
              href="#point"
              className={`flex items-center gap-1 px-3 py-2 text-xs whitespace-nowrap transition-colors duration-300 cursor-pointer ${
                scrolled ? "text-[#78716C] hover:text-[#1C1917]" : "text-white/70 hover:text-white"
              }`}
            >
              <i className="ri-gift-line text-sm" />
              ポイント
            </a>
          </div>

          {/* Hamburger */}
          <button
            className={`md:hidden ml-auto transition-colors ${scrolled ? "text-[#1C1917]" : "text-white"}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="メニューを開く"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-white pt-16">
          <div className="px-6 py-8 flex flex-col gap-6">
            {[
              { label: "初めての方へ", href: "#about" },
              { label: "足タイプから探す", href: "#diagnosis" },
              { label: "お悩みから探す", href: "#troubles" },
              { label: "商品を見る", href: "#products" },
              { label: "来店・診断", href: "#consultation" },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="text-base text-[#1C1917] border-b border-[#F5F0EA] pb-4 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <div className="flex flex-col gap-3 mt-4">
              <a
                href="#line"
                className="flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-[#1C1917] text-[#1C1917] text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-line-fill" />
                LINE相談
              </a>
              <a
                href="#consultation"
                className="flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#1C1917] text-white text-sm whitespace-nowrap cursor-pointer"
              >
                来店予約
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}